import GoogleMapsApi from './api.js';
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

const LoadGoogleMaps = function ({ settings }) {
    if (!settings || !settings.mapSelector || !settings.locations) {
        return;
    }
    this.config = settings;
    this.createMap();
};

/*----------------------------GET MAPSTYLE ------------------------------*/
LoadGoogleMaps.prototype.getMapStyle = function (style) {
    //--------MAP STYLES. Available map styles. You can create a new style at https://mapstyle.withgoogle.com/
    const mapStyles = {
        silver: new google.maps.StyledMapType(
            [
                {
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5'
                        }
                    ]
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#616161'
                        }
                    ]
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#f5f5f5'
                        }
                    ]
                },
                {
                    featureType: 'administrative.land_parcel',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#bdbdbd'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#eeeeee'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#757575'
                        }
                    ]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#e5e5e5'
                        }
                    ]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#9e9e9e'
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff'
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#757575'
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#dadada'
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#616161'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#9e9e9e'
                        }
                    ]
                },
                {
                    featureType: 'transit.line',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#e5e5e5'
                        }
                    ]
                },
                {
                    featureType: 'transit.station',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#eeeeee'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#c9c9c9'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#9e9e9e'
                        }
                    ]
                }
            ],
            { name: style }
        )
    };
    return mapStyles[style];
};

/*----------------------------CREATE THE MAP ------------------------------*/
LoadGoogleMaps.prototype.createMap = function () {
    const {
        mapSelector,
        mapStyle,
        mapSettings,
        locations,
        markerImage,
        markerUrls,
        infoWindows,
        markerUrlGtmCategory
    } = this.config;

    const map = new google.maps.Map(document.getElementById(mapSelector), mapSettings);

    const bounds = new google.maps.LatLngBounds();

    /*-------------------------Add link to marker-------------------------*/
    const addMarkerLink = function (marker, url, name) {
        marker.addListener('click', () => {
            window.location.href = url; //Go to url

            if (markerUrlGtmCategory && name) {
                trackEvent(markerUrlGtmCategory, 'Marker Google Maps', name);
            }
        });
    };

    /*-------------------------Add info window to marker-------------------------*/
    const addInfoWindow = (marker, infoWindow) => {
        marker.addListener('click', () => {
            infoWindow.open(map, marker);
        });
    };

    if (mapStyle) {
        //Associate the styled map with the MapTypeId and set it to display.
        const selectedStyle = this.getMapStyle(mapStyle);
        map.mapTypes.set(mapStyle, selectedStyle);
        map.setMapTypeId(mapStyle);
    }

    if (locations) {
        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];
            const marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(location[1]),
                    lng: parseFloat(location[2])
                },
                map: map,
                icon: markerImage,
                title: location[0],
                zIndex: parseInt(location[3])
            });

            //Get latlang from marker so we can auto calculate zoom and center
            const loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(loc);

            if (markerUrls && markerUrls[i]) {
                addMarkerLink(marker, markerUrls[i], location[0]);
            }

            if (infoWindows && infoWindows[i]) {
                const infoWindowContent = infoWindows[i];
                const infoWindow = new google.maps.InfoWindow({
                    content: infoWindowContent['content']
                });
                addInfoWindow(marker, infoWindow);

                if (infoWindowContent['openOnLoad']) {
                    infoWindow.open(map, marker);
                }
            }
        }

        //Auto zoom and center map
        if (!mapSettings.zoom && !mapSettings.center) {
            map.fitBounds(bounds);
            map.panToBounds(bounds);
        }
    }
};

/*----------------------------CALLBACK FUNCTION USED TO LOAD THE MAP.
This is the callback function defined in templates > global > javascript > javascript.tpl. ------------------------------*/
/* exported initMap */

const initMap = function () {
    const maps = document.querySelectorAll('.google-map-container');
    if (maps) {
        maps.forEach((map) => {
            const mapSettings = map.getAttribute('data-map-settings');

            if (mapSettings) {
                new LoadGoogleMaps({ settings: JSON.parse(mapSettings) });
            }
        });
    }
};

export const loadMaps = () => {
    const gmapApi = new GoogleMapsApi(frontendVars.googleMapsApiKey);
    gmapApi.load().then(() => {
        initMap();
    });
};
